import { Component, EventEmitter,Input, OnInit,Output, HostListener, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "../services/common.service";
import { ToastrService } from "ngx-toastr";
import  {  MatTreeFlatDataSource,MatTreeFlattener, MatTreeModule} from "@angular/material/tree"
import { FlatTreeControl } from "@angular/cdk/tree";
import { of as observableOf } from "rxjs";
import { v4 as uuidv4 } from "uuid";
import { FileViewExplorerComponent } from "src/app/file-view-explorer/file-view-explorer.component";
import { V, X } from "@angular/cdk/keycodes";
import { Hl7viewerComponent } from "../hl7viewer/hl7viewer.component";

declare var $;

@Component({
  selector: "app-ftpfiles",
  templateUrl: "./ftpfiles.component.html",
  styleUrls: ["./ftpfiles.component.scss"],
})
export class FtpfilesComponent implements OnInit, OnDestroy {

  @Input() inputDataInModalComponent: any;
  @Output() fileContent = new EventEmitter<{filecontent: string; filename: string }>();
  formatType: string = "text/plain";
  filehistory: any[] = [];
  leftNav:boolean= true
  folderempty:boolean;
  childfiles: any = [];
  backupfolders: any;
  fileexplorerheight: number = 0;
  externalconectivityflag:boolean=false;
  externaftpSuggestion:string="*NOTE :For External FTP Users, Viewing And Moving Files Not Be Allowed"
  searchForm: FormGroup = this._formBuilder.group({
    search: "",
  });
  interfaceDetails: any;
  pdfSrc: string;
  isRead: boolean = false;
  editorOptions= {theme: 'vs', language: this.formatType,readOnly:true, wordWrap: 'on',scrollBeyondLastLine: false
};
  DisplaynameRoute: any;
  uniqfilesdata=[];
  selectedFileItem: any;
  filecountdisplay: unknown;
  DestfolList:any
  fileName: any;
  editorInit(editor: any) {
      if (
        this.selectedfilecontent !== "" &&
        this.selectedfilecontent !== undefined
      ) {
        if (this.selectedfilecontent.startsWith("<")) {
          this.formatType = "xml";
        } else if (this.selectedfilecontent.startsWith("{")) {
          this.formatType = "json";
        }
      }

      this.editorOptions = { ...this.editorOptions, language: this.formatType };
      // this.formatXml(this.inputtemplatexml);
  }

  screenHeight: number;
  private currentNestedModalRefs: any[] = [];
  private nestedModalWasOpen = false;
  constructor(
    private ngxUiLoaderService: NgxUiLoaderService,
    public service: CommonService,
    private activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private modalService: NgbModal,
    private router: Router,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder
  ) {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren
    );
    this.treeControl = new FlatTreeControl<TreeNode>(
      this.getLevel,
      this.isExpandable
    );
    this.FTPFilesList = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );
    this.DestfolList = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );
    // this.FTPFilesList.data = files;
  }

  ngOnChanges() {
this.inputDataInModalComponent.case360 !== undefined ? this.leftNav = false:true;
this.getFTPfiles();
  }
  pagerolepermisions: any = [];
  async ngOnInit() {
    this.fileexplorerheight = window.innerHeight - 40;
    this.screenHeight = window.innerHeight - 229;
    
    // Adjust modal height on init
    this.adjustModalHeight();
    
    if ((await this.service.checksession()) == true) {
      const menuid = JSON.parse(sessionStorage.getItem("rolewithmenus"))
        .find((x) => x.RoleName == sessionStorage.getItem("SelectedUserRole"))
        .menuslist.find((y) => y.MenuName == "createpipeline").MenuId;
      const actionitems = JSON.parse(sessionStorage.getItem("rolewithmenus"))
        .find((x) => x.RoleName == sessionStorage.getItem("SelectedUserRole"))
        .menuslist.filter((y) => y.ParentMenuId == menuid);
      actionitems.forEach((element) => {
        this.pagerolepermisions[element.MenuName] = true;
      });
      if (this.pagerolepermisions != undefined) {
        // this.FTPFilesList.data=[]
        this.childfiles = [];
        this.filenamesearch = "";
        await this.getFTPfiles();
      }
    }
  }

  // Adjust modal height based on window.innerHeight while preserving top and left positions
  private adjustModalHeight() {
    setTimeout(() => {
      const viewportHeight = window.innerHeight;
      const headerElement = document.querySelector('.row.white') as HTMLElement;
      const headerHeight = headerElement ? headerElement.getBoundingClientRect().height : 60;
      
      // Calculate modal height (viewport height - header - some padding)
      const modalHeight = viewportHeight - headerHeight - 30;
      
      // Find the modal element (this component is a modal itself)
      const modalElement = document.querySelector('.modal.show') as HTMLElement;
      if (modalElement) {
        // Get existing top and left positions from computed style or inline style
        const computedStyle = window.getComputedStyle(modalElement);
        const existingTop = modalElement.style.top || (computedStyle.top !== 'auto' ? computedStyle.top : '');
        const existingLeft = modalElement.style.left || (computedStyle.left !== 'auto' ? computedStyle.left : '');
        
        // Only adjust height, preserve top and left if they exist
        modalElement.style.height = `${modalHeight}px`;
        if (existingTop && existingTop !== 'auto' && existingTop !== '') {
          modalElement.style.top = existingTop;
        }
        if (existingLeft && existingLeft !== 'auto' && existingLeft !== '') {
          modalElement.style.left = existingLeft;
        }
      }
      
      // Also adjust backdrop height (preserve top and left)
      const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
      if (backdrop) {
        const backdropComputedStyle = window.getComputedStyle(backdrop);
        const backdropExistingTop = backdrop.style.top || (backdropComputedStyle.top !== 'auto' ? backdropComputedStyle.top : '');
        const backdropExistingLeft = backdrop.style.left || (backdropComputedStyle.left !== 'auto' ? backdropComputedStyle.left : '');
        
        backdrop.style.height = `${modalHeight}px`;
        if (backdropExistingTop && backdropExistingTop !== 'auto' && backdropExistingTop !== '') {
          backdrop.style.top = backdropExistingTop;
        }
        if (backdropExistingLeft && backdropExistingLeft !== 'auto' && backdropExistingLeft !== '') {
          backdrop.style.left = backdropExistingLeft;
        }
      }
    }, 100);
  }

  // Adjust modal height on window resize
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.adjustModalHeight();
    // Also update internal height calculations
    this.fileexplorerheight = window.innerHeight - 40;
    this.screenHeight = window.innerHeight - 229;
  }

  // Hide nested hl7viewer modals
  hideNestedModals() {
    if (this.currentNestedModalRefs && this.currentNestedModalRefs.length > 0) {
      // Find nested hl7viewer modals
      let nestedModals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7[data-ftpfiles-hl7viewer-modal="true"]') as NodeListOf<HTMLElement>;
      if (nestedModals.length === 0) {
        nestedModals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7') as NodeListOf<HTMLElement>;
      }
      
      nestedModals.forEach(nestedModal => {
        const nestedStyle = window.getComputedStyle(nestedModal);
        if (nestedModal.classList.contains('show') || (nestedStyle.display !== 'none' && nestedStyle.display !== '')) {
          nestedModal.setAttribute('data-ftpfiles-hl7viewer-modal', 'true');
          nestedModal.style.setProperty('display', 'none', 'important');
          // Keep 'show' class to prevent Bootstrap from detecting this as dismissal
        }
      });
      
      // Hide nested modal backdrops
      const nestedBackdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-ftpfiles-hl7viewer-modal="true"]')) as HTMLElement[];
      nestedBackdrops.forEach(nestedBackdrop => {
        const backdropStyle = window.getComputedStyle(nestedBackdrop);
        if (backdropStyle.display !== 'none') {
          nestedBackdrop.style.setProperty('display', 'none', 'important');
        }
      });
    }
  }

  // Show nested hl7viewer modals
  showNestedModals() {
    if (this.nestedModalWasOpen && this.currentNestedModalRefs && this.currentNestedModalRefs.length > 0) {
      setTimeout(() => {
        // Find nested hl7viewer modals
        let nestedModals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7[data-ftpfiles-hl7viewer-modal="true"]') as NodeListOf<HTMLElement>;
        if (nestedModals.length === 0) {
          nestedModals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7') as NodeListOf<HTMLElement>;
        }
        
        nestedModals.forEach(nestedModal => {
          const nestedStyle = window.getComputedStyle(nestedModal);
          if (nestedStyle.display === 'none' || !nestedModal.classList.contains('show')) {
            nestedModal.style.setProperty('display', 'block', 'important');
            if (!nestedModal.classList.contains('show')) {
              nestedModal.classList.add('show');
            }
          }
        });
        
        // Show nested modal backdrops
        const nestedBackdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-ftpfiles-hl7viewer-modal="true"]')) as HTMLElement[];
        nestedBackdrops.forEach(nestedBackdrop => {
          const backdropStyle = window.getComputedStyle(nestedBackdrop);
          if (backdropStyle.display === 'none') {
            nestedBackdrop.style.setProperty('display', 'block', 'important');
            if (!nestedBackdrop.classList.contains('show')) {
              nestedBackdrop.classList.add('show');
            }
          }
        });
      }, 150);
    }
  }

  /** The TreeControl controls the expand/collapse state of tree nodes.  */
  treeControl: FlatTreeControl<TreeNode>;
  /** The TreeFlattener is used to generate the flat list of items from hierarchical data. */
  treeFlattener: MatTreeFlattener<FileNode, TreeNode>;
  /** The MatTreeFlatDataSource connects the control and flattener to provide data. */
  FTPFilesList: MatTreeFlatDataSource<FileNode, TreeNode>;

  /** Transform the data to something the tree can read. */
  transformer(node: FileNode, level: number) {
    return {
      foldername: node.foldername,
      type: node.type,
      level: level,
      expandable: !!node.subfolders,
      size: node.size,
      lastmodifieddate: node.lastmodifieddate,
      subfolders: node.subfolders,
      filelist: node.filelist,
      fullpath: node.folderpath,
      guid: node.guid,
    };
  }

  /** Get the level of the node */
  getLevel(node: TreeNode) {
    return node.level;
  }
iscalled:number=0;
  /** Return whether the node is expanded or not. */
  isExpandable(node: TreeNode) {
      return node.expandable;
  }

  /** Get the children for the node. */
  getChildren(node: FileNode) {
    return observableOf(node.subfolders);
  }

  /** Get whether the node has children or not. */
  hasChild(index: number, node: TreeNode) {
    return node.expandable;
  }

  createGuid(data: any) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].foldername !== undefined) {
        data[i]["guid"] = uuidv4();
        data[i].expandable = false;
        if (data[i].subfolders !== undefined && data[i].subfolders.length > 0) {
          this.createGuid(data[i].subfolders);
        }
      }
    }
    return data;
  }

  numberoffilesshow: number;
  selectcontentflag: boolean = false;
  getFTPfiles() {
   
    this.ngxUiLoaderService.start();
    if (this.inputDataInModalComponent.selectflag) {
      this.selectcontentflag = this.inputDataInModalComponent.selectflag;
    }
    if(this.inputDataInModalComponent.connectivitytype==="External FTP"&&this.inputDataInModalComponent.connectivitytype!==undefined)
    {
        this.externalconectivityflag=true;
    }

    this.DisplaynameRoute = this.inputDataInModalComponent.name;
    var apiname =
      "api/Routes/GetFTPFilesExplorer?RouteId=" +
      this.inputDataInModalComponent.routeId +
      "&SourceagentID=" +
      this.inputDataInModalComponent.sourceagent +
      "&Filename=" +
      this.filenamesearch;
    // var apiname = "api/Routes/GetFTPFilesExplorer?RouteId=43BEE9EB-421D-4B94-A1DD-A9F623F22E8C&SourceagentID=F3ECBF3D-FA0D-AFD5-BF3E-7AE5BB6EADC4&Filename=";

    this.service.getapiurl(apiname).subscribe({
      next: (response) => {
        if (response.length > 0) {
          this.filecountdisplay = response[0].filecountshow
          response[0] = this.deleteproperty(response[0] as any[]);
          this.FTPFilesList.data = this.createGuid(response);
          this.DestfolList.data=this.FTPFilesList.data;
          this.getFolderdata();
        }
        this.ngxUiLoaderService.stop();
      },
      error: (error) => {
        this.ngxUiLoaderService.stop();

        this.toastr.error(
          "Failed"+" "+ error["statusText"],
          "",
          {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          }
        );
        this.service.copyableToastError(error["statusText"]);
      },
    });
  }
  getFolderdata() {
    // this.modalService.open(exampleModalRight)
    // $("#exampleModalRight").modal('show');
    this.filediv(this.FTPFilesList.data[0]);
  }
  eventfilediv(filesData: any,event:MouseEvent){
    const target = event.target as HTMLElement;
    if(target.tagName.toLowerCase()!='mat-icon'){
      this.filediv(filesData);
    }
  }
  filediv(filesData: any) {
       if(filesData.type !== "file" ){
    this.folderempty = true;
    this.isRead = false;
    }

    this.filenamesearch = "";
    if(filesData.conectivitytype==="External FTP"&&filesData.conectivitytype!==undefined)
    {
      this.externalconectivityflag=true;

    }
    if (filesData.type == "file"&&!this.externalconectivityflag) {
      this.childfiles.map(da => da.isRead = false)
      this.getfilecontent(filesData);
    } else {
      this.isRead = false;
      this.selectedftpfilesList=[];
      if (!filesData.guid) {
        filesData.guid = this.FTPFilesList.data[0].guid
      }
      let paths = this.getAncestors(this.FTPFilesList.data, filesData.guid);
      if (paths.length > 0) {
        let files = paths[paths.length - 1];
        this.treeControl.collapseAll();
        for (let k = 0; k < paths.length; k++) {
          let indd = this.treeControl.dataNodes.findIndex(
            (va) => va.guid === paths[k].guid
          );
          this.treeControl.expand(this.treeControl.dataNodes[indd]);
        }
        let index = files.level;
        this.filehistory.splice(index, this.filehistory.length - index);
        this.filehistory = paths;
        if (files.subfolders !== undefined && files.filelist.length > 0) {
          this.childfiles = [...files.subfolders, ...files.filelist];
        } else if (files.subfolders == undefined && files.filelist.length > 0) {
          this.childfiles = [...files.filelist];
        } else if (
          files.subfolders !== undefined &&
          files.filelist.length == 0
        ) {
          this.childfiles = [...files.subfolders];
        } else {
          this.childfiles = [];
        }
        if (this.childfiles !== undefined) {
          this.backupfolders = JSON.parse(JSON.stringify(this.childfiles));
        }
      }
    }
    this.childfiles.map(va => va.isRead = false)
  }

  getAncestors(array: any, name: any) {
    if (typeof array != "undefined") {
      for (let i = 0; i < array.length; i++) {
        if (array[i].guid === name) {
          return [array[i]];
        }
        let a: any = this.getAncestors(array[i].subfolders, name);
        if (a !== null) {
          a.unshift(array[i]);
          return a;
        }
      }
    }
    return null;
  }

  deleteproperty(dataitem) {
    dataitem.subfolders.forEach((element) => {
      if (element.subfolders.length == 0) {
        delete element.subfolders;
      } else {
        element = this.deleteproperty(element);
      }
    });
    return dataitem;
  }

  displayedColumns: string[] = [
    "checkbox",
    "icon",
    "name",
    "lastmodifieddate",
    "size",
  ];
  selectedfolderfilelist: any = [];
  filesListShow(s) {
    this.selectedfolderfilelist = [];
    s.filelist.forEach((element) => {
      element.foldername = s.foldername;
      element.level = s.level;
      this.selectedfolderfilelist.push(element);
    });
  }
  selectedestfolpath:string=""
  selectedestfolname:string=""
  selectedestfol(node)
  {

    this.selectedestfolpath=""
    this.selectedestfolname=""
    this.selectedestfolpath=node.fullpath
    this.selectedestfolname=node.foldername

  }

  selectedfilecontent: any;
  mediatypedisplay: boolean = true;
  async getfilecontent(event) {
   
    if(event.size !== "0"){
      this.selectedFileItem = event;
      this.fileName=event.name;
    const datainput = {
      filename: event.name,
      filepath: event.fullName,
      routeid: this.inputDataInModalComponent.routeId,
      agentid: this.inputDataInModalComponent.sourceagent,
      createdby:JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
    };
    // const datainput = {
    //   "filename": event.name,
    //   "filepath": event.fullName,
    //   "routeid": "43BEE9EB-421D-4B94-A1DD-A9F623F22E8C",
    //   "agentid": "F3ECBF3D-FA0D-AFD5-BF3E-7AE5BB6EADC4"
    // }
    this.ngxUiLoaderService.start();
    var response = await this.service.postapi(
      "api/Routes/GetFTPFileContent",
      datainput
    );
  
    if (response["status"] && response["statusText"]) {
      this.ngxUiLoaderService.stop();
      this.toastr.error(
        "Failure to get file content. error " + response["statusText"],
        "",
        {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        }
      );
    } else {
      this.ngxUiLoaderService.stop();
      const result = response as any[];
      //
      event['isRead']=true
      if (result["status"] == ".pdf") {
        this.isRead=true;
        this.mediatypedisplay = false;
        this.selectedfilecontent = response.responsebody;
        if (this.inputDataInModalComponent.selectflag != undefined && this.inputDataInModalComponent.selectflag === true) {
          this.fileContent.emit({filecontent:this.selectedfilecontent,filename:this.fileName});
          this.activeModal.close();
        }
        this.selectedfilecontent = this._base64ToArrayBuffer(result["responsebody"]);
      //   let namemodal = {
      //     name: event.name,
      //     fullfile: result["responsebody"],
      //   };
      //   const modalRef = this.modalService.open(FileViewExplorerComponent, {
      //     windowClass: "myCustomModalViewfile",
      //     backdrop: "static",
      //     keyboard: false,
      //   });
      //   modalRef.componentInstance.fileData = namemodal;
      //   modalRef.result.then(() => {});
      } else {
        this.isRead = true;
        this.mediatypedisplay = true;
        this.selectedfilecontent = result["responsebody"];        
        if (this.inputDataInModalComponent.selectflag!=undefined &&this.inputDataInModalComponent.selectflag === true) {
          this.fileContent.emit({filecontent:this.selectedfilecontent,filename:this.fileName});
          this.activeModal.close();
        }else{        
        if(this.selectedfilecontent.startsWith('MSH|^'))
        {
          if(this.selectedfilecontent==null){

            this.toastr.error("The given input is empty", "", {
             timeOut: 4000,
             positionClass: "toast-bottom-right",
           });
           return
         }
         if (this.selectedfilecontent.startsWith('MSH|^') &&  this.inputDataInModalComponent.selectflag!=undefined && this.inputDataInModalComponent.selectflag === false) {
          this.isRead = false;
           const modalRef = this.modalService.open(Hl7viewerComponent,
             { windowClass: "myCustomModalClassFTPHL7", backdrop: 'static', keyboard: false });
           modalRef.componentInstance.inputDataInModalComponent = this.selectedfilecontent;
           
           // Track nested modal
           this.currentNestedModalRefs.push(modalRef);
           this.nestedModalWasOpen = true;
           
           modalRef.result.then(() => {
             this.currentNestedModalRefs = this.currentNestedModalRefs.filter(ref => ref !== modalRef);
             if (this.currentNestedModalRefs.length === 0) {
               this.nestedModalWasOpen = false;
             }
           }, (reason) => {
             this.currentNestedModalRefs = this.currentNestedModalRefs.filter(ref => ref !== modalRef);
             if (this.currentNestedModalRefs.length === 0) {
               this.nestedModalWasOpen = false;
             }
           });
           
           // Add data attribute to identify nested modal
           setTimeout(() => {
             const nestedModalElement = document.querySelector('.modal.myCustomModalClassFTPHL7') as HTMLElement;
             if (nestedModalElement) {
               nestedModalElement.setAttribute('data-ftpfiles-hl7viewer-modal', 'true');
             }
             const nestedBackdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
             if (nestedBackdrop && !nestedBackdrop.hasAttribute('data-ftpfiles-modal')) {
               nestedBackdrop.setAttribute('data-ftpfiles-hl7viewer-modal', 'true');
             }
           }, 100);
         }
        }
      }
      }
    }
  }else{
          this.toastr.warning(" No file content", '0 Bytes ',{
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        }
      );
  }
  }
  units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  niceBytes(x: any) {
    let l = 0,
      n = parseInt(x, 10) || 0;
    while (n >= 1024 && ++l) {
      n = n / 1024;
    }
    return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + this.units[l];
  }
  // _base64ToArrayBuffer(base64) {
  //   const binary_string = window.atob(base64);
  //   const len = binary_string.length;
  //   const bytes = new Uint8Array(len);
  //   for (let i = 0; i < len; i++) {
  //     bytes[i] = binary_string.charCodeAt(i);
  //   }
  //   return bytes.buffer;
  // }
  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string =  window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array( len );
    for (var i = 0; i < len; i++)        {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  filenamesearch: string = "";
  refresh() {
    this.filenamesearch = "";
    this.selectedftpfilesList=[];
    this.getFTPfiles();
  }
  closetpopup() {
    this.childfiles = [];
    this.service.closeviewFile(true);
    this.activeModal.close();

  }

  closetpopupRead() {
    this.isRead = false;
    this.selectedFileItem.isRead = false;
  }

  activeNode;
  searchftpfiles() {
    if (this.filenamesearch !== "") {
      this.ngxUiLoaderService.start();
      if (this.inputDataInModalComponent.selectflag) {
        this.selectcontentflag = this.inputDataInModalComponent.selectflag;
      }
      var apiname =
        "api/Routes/GetFTPFilesExplorer?RouteId=" +
        this.inputDataInModalComponent.routeId +
        "&SourceagentID=" +
        this.inputDataInModalComponent.sourceagent +
        "&Filename=" +
        this.filenamesearch;

      this.service.getapiurl(apiname).subscribe(response => {
          ;
          if (response.length > 0) {
            this.ngxUiLoaderService.stop();
            if(response[0]['foldername']==this.FTPFilesList.data[0]['foldername']){
              response[0]['guid']=this.FTPFilesList.data[0]['guid']
            }
            if(this.FTPFilesList.data[0]['subfolders'].length>0){
              this.FTPFilesList.data[0]['subfolders'].forEach(X => {
                response[0]['subfolders'].forEach(V=>{
                  if(X['foldername']==V['foldername']){
                    V['guid']=X['guid']
                  }
                });
              });
            }
            response[0] = this.deleteproperty(response[0] as any[]);
            // this.FTPFilesList.data = response as any[];
            this.treeControl.expand(this.treeControl.dataNodes[0]);

            let pathshistorydata=response;
            let paths = this.getAncestors(pathshistorydata, pathshistorydata[0].guid);
            this.selectedfolderfilelist = [];
            this.uniqfilesdata =[]
            this.isRead=false;
            this.filehistory = paths.length>0?paths:[];
            this.childfiles = this.uniqFiles(response);
            if(this.childfiles.length ==0){
              this.folderempty = false;
              this.toastr.warning(
                "Files Not Found",
                "",
                {
                  timeOut: 4000,
                  positionClass: "toast-bottom-right",
                }
              );
            }
            this.numberoffilesshow = response[0].filecountshow;
          }

        },error => {
          this.ngxUiLoaderService.stop();
        },
      );
    }
  }

  uniqFiles(files, path = []) {
    if (!files || files.length === 0) return [];

    for (let file of files) {
      const folder = file;
      const newPath = [...path, { foldername: folder.foldername }];
      if (folder.filelist && folder.filelist.length > 0) {
        this.uniqfilesdata = this.uniqfilesdata.concat(folder.filelist);
        this.filehistory = newPath;
      }
      if (folder.subfolders && folder.subfolders.length > 0) {
        this.uniqFiles(folder.subfolders, newPath);
      }
    }
    return this.uniqfilesdata;
  }

  selectedftpfilesList: any[] = [];
  async Selectedftpfiles(item, checkvalue) {
    
    if (checkvalue) {
      this.selectedftpfilesList.push(item);
    } else {
      this.selectedftpfilesList = this.selectedftpfilesList.filter(
        (element) => element.fullName !== item.fullName
      );
      // this.selectedftpfilesList.forEach((element) => {
      //   if (element.fullName === item.fullName) {
      //     this.selectedftpfilesList.splice(
      //       this.selectedftpfilesList.indexOf(item.fullName),
      //       1
      //     );
      //   }
      // });
    }
  }
sourcepathfile:unknown
selectdestinationfolderpop(modalrefid)
{
  this.selectedestfolpath="";
  if(this.selectedftpfilesList.length>0){
    this.selectedftpfilesList.forEach((element) => {
      this.sourcepathfile= element.fullName;
    })
  }

  this.modalService
  .open(modalrefid, {
    windowClass: "viewfiles",
    backdrop: "static",
    keyboard: false,
  })
  .result.then((result) => {});
}

closedestfolpopup(c) {
  this.sourcepathfile=""
  this.selectedestfolpath=""
  c("close modal");
}

  async SelectedftpfilesMove(c) {
if(this.selectedestfolpath != ''){
    this.ngxUiLoaderService.start();
    const fileinfo = [];
    if(this.selectedftpfilesList.length>0){
      this.selectedftpfilesList.forEach((element) => {
        fileinfo.push({
          name: element.name,
          fullName: element.fullName,
          lastmodifieddate: element.lastmodifieddate,
          type: element.type,
          size: element.size,
          destinationfolder:this.selectedestfolpath
        });
      });
    }

    const filesmove = {
      routeUniqueID: this.inputDataInModalComponent.uniqid,
      RouteId: this.inputDataInModalComponent.routeId,
      SourceAgentId: this.inputDataInModalComponent.sourceagent,
      FTPFilesInfo: fileinfo,
      CreatedBy: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
    };
    let responseroutedata = await this.service.postapi(
      "api/Routes/FTPFilesMoveToRootFolder",
      filesmove
    );

    // if ( (responseroutedata["status"] && responseroutedata["statusText"]) || responseroutedata["statusText"] === "Unknown Error" ) {
    //   this.ngxUiLoaderService.stop();

    //   this.toastr.error(
    //     "Failure to move FTP files to root folder or File already exists in root folder",
    //     responseroutedata["statusmessage"],
    //     {
    //       timeOut: 4000,
    //       positionClass: "toast-bottom-right",
    //     }
    //   );
    // } else {
      let lastpath
      if(this.selectedestfolpath.includes("/") || this.selectedestfolpath.includes("\\")){

        lastpath = this.selectedestfolpath.split(/[/\\]/)
        if(lastpath.length){
          lastpath = lastpath[lastpath.length-1]
        }
      }
      if(responseroutedata.status!=200){
        this.toastr.error(
          `Error moving files`,
          "",
          {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          }
        );
        c("close modal");
        this.ngxUiLoaderService.stop();
}
else{
  this.toastr.success(
    `Selected FTP files moved to ${lastpath} folder Successfully`,
    "",
    {
      timeOut: 500,
      positionClass: "toast-bottom-right",
    }
  );
  c("close modal");
  this.ngxUiLoaderService.stop();
}
this.selectedftpfilesList = [];
      this.getFTPfiles();
    }else{
      this.toastr.warning("Destination Path is Mandatory", 'Warning ',{
        timeOut: 4000,
        positionClass: "toast-bottom-right",

    })
  }
  }

  clearsearchbox() {
    this.filenamesearch = "";
    this.folderempty = true;
  }

  selectcontentandclose(content) {
    this.activeModal.close(content);
  }

  searchfile(arr: any, searchinput: any) {
    for (var i of arr) {
      if (i.foldername.includes(searchinput)) {
        return this.filediv(i);
      }
    }
    if (i) {
      this.searchfile(i.subfolders, searchinput);
    }
  }

  // onSubmit() {
  //   this.searchfile(this.FTPFilesList.data, this.searchForm.value.search);
  // }

  // downloadFile(value:any){

  //   let path = value.fullName.split("/");
  //   if(path.length>0){
  //     let index = path.length-1
  //     path.splice(index,1)
  //    path= path.join("/")
  //   }
  //   let obj ={
  //      "path":path+"/",
  //      "interfaceid":this.interfaceDetails.InterfaceId,
  //      "filename":value.filename
  //     }

  //     this.ngxUiLoaderService.start()
  //   this.service.viewFile(obj).subscribe(data =>{
  //     if(data.fullfile !== null){

  // this.pdfSrc = data.fullfile;
  // let namemodal={
  //   name:data.filename,
  //   fullfile:data.fullfile
  // }
  // const modalRef = this.modalService.open(FileViewExplorerComponent
  //   , {
  //   windowClass: "myCustomModalViewfile",
  //   backdrop: "static",
  //   keyboard: false
  // });
  // modalRef.componentInstance.fileData =namemodal ;
  // modalRef.result.then(() => { });
  // this.ngxUiLoaderService.stop()

  //     }else{
  //       this.ngxUiLoaderService.stop()

  //     }
  //   },error=>{
  //     this.ngxUiLoaderService.stop()
  //   })
  // }
  checkboxEnable(history){

    if(history.length>0){
      for (let i = 0; i < history.length; i++) {
        const element = history[i];
        if( history[i].foldername.toLowerCase() == 'error' ||  history[i].foldername.toLowerCase()  == 'progress'  ||  history[i].foldername.toLowerCase()  == 'archive'  ){
          return true;
        }
      }
    }

  }
  showimg(value) {
    if (value !== undefined) {
      return value.split(".")[1];
    }
  }

  ngOnDestory() {
    this.childfiles = [];
    this.treeControl.dataNodes = [];
    this.FTPFilesList.data = [];
    this.DestfolList.data = [];
    this.filenamesearch = "";
  }

  HL7Viewer(HL7Content:string)
  {
    if(HL7Content==null){

      this.toastr.error("The given input is empty", "", {
       timeOut: 4000,
       positionClass: "toast-bottom-right",
     });
     return
   }
   if (HL7Content.startsWith('MSH|^')) {
     const modalRef = this.modalService.open(Hl7viewerComponent,
       { windowClass: "myCustomModalClassFTPHL7", backdrop: 'static', keyboard: false });
     modalRef.componentInstance.inputDataInModalComponent = HL7Content;
     
     // Track nested modal
     this.currentNestedModalRefs.push(modalRef);
     this.nestedModalWasOpen = true;
     
     modalRef.result.then(() => {
       this.currentNestedModalRefs = this.currentNestedModalRefs.filter(ref => ref !== modalRef);
       if (this.currentNestedModalRefs.length === 0) {
         this.nestedModalWasOpen = false;
       }
     }, (reason) => {
       this.currentNestedModalRefs = this.currentNestedModalRefs.filter(ref => ref !== modalRef);
       if (this.currentNestedModalRefs.length === 0) {
         this.nestedModalWasOpen = false;
       }
     });
     
     // Add data attribute to identify nested modal
     setTimeout(() => {
       const nestedModalElement = document.querySelector('.modal.myCustomModalClassFTPHL7') as HTMLElement;
       if (nestedModalElement) {
         nestedModalElement.setAttribute('data-ftpfiles-hl7viewer-modal', 'true');
       }
       const nestedBackdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
       if (nestedBackdrop && !nestedBackdrop.hasAttribute('data-ftpfiles-modal')) {
         nestedBackdrop.setAttribute('data-ftpfiles-hl7viewer-modal', 'true');
       }
     }, 100);
   }
  }

  ngOnDestroy() {
    // Close nested modals
    if (this.currentNestedModalRefs && this.currentNestedModalRefs.length > 0) {
      this.currentNestedModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentNestedModalRefs = [];
    }
  }
}
/** File node data with nested structure. */
export interface FileNode {
  foldername: string;
  folderpath: string;
  level: number;
  type: string;
  size: any;
  lastmodifieddate: any;
  subfolders?: FileNode[];
  filelist?: FileTreeNode[];
  guid: string;
}

/** Flat node with expandable and level information */
export interface TreeNode {
  foldername: string;
  level: number;
  expandable: boolean;
  filelist?: FileTreeNode[];
  subfolders?: FileNode[];
  guid: string;
}

/** Flat node with expandable and level information */
export interface FileTreeNode {
  name: string;
  fullName: string;
  type: number;
  size: string;
  lastmodifieddate: string;
}
